export const formatSearchedLocation = (location: string) =>
  location.split(",")[0];
